<template>
  <div>
    <div class="topBox" >
      <el-breadcrumb separator-class="el-icon-arrow-right" >
        <template v-if="$store.state.tabnavBox  && $store.state.tabnavBox.length > 0">
            <el-breadcrumb-item v-for="(item, index) in $store.state.tabnavBox" :key="index" :to="item.path"
                               >
              {{item.title}}
            </el-breadcrumb-item>
        </template>
      </el-breadcrumb>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'tabNav',
    data () {
      return {
        rightMenuShow: false,
        left: 0,
        top: 0
      }
    },
    methods: {
      openMenu (item, e, index) {
        if (index === 0) {
          return false
        }
        let l = this.$store.state.isCollapse ? 60 : 200
        this.rightMenuShow = true
        this.left = e.clientX -l
        this.top = e.clientY - 55
        this.$store.dispatch('openMenu', item)
        console.log(item)
      },
      removeTab (tabItem) {
        this.$store.dispatch('removeTab', {tabItem, fullPath: this.$route.fullPath, router: this.$router})
      },
      removeOtherTab (tabItem) {
        this.$store.dispatch('removeOtherTab', {tabItem, router: this.$router})
      },
      removeAllTab () {
        this.$store.dispatch('removeOtherTab', {all: true, router: this.$router})
      }
    },
    watch: {
      rightMenuShow (value) {
        if (value) {
          document.body.addEventListener('click', () => {
            this.rightMenuShow = false
          })
        } else {
          document.body.removeEventListener('click', () => {
            this.rightMenuShow = false
          })
        }
      }
    },
    mounted () {
    }
  }
</script>

<style lang="scss" scoped>

  .topBox {
    //margin: 15px;
    margin-top: 12px;
    padding-left: 20px;
  }
</style>




// WEBPACK FOOTER //
// src/components/common/tabNav.vue